import { createContext } from 'react';

import { SupplierOnboardingRequestMessage } from '../../../../../../types/SupplierOnboardingRequestMessage';
import { OfferModel } from '../../../../../offer/model/OfferModel';
import { OrderModel } from '../../../../model/OrderModel';

interface OfferCardContextInterface {
    offer: OfferModel;
    order: OrderModel;
    isLastOpenOffer: boolean;
    isSpotAvailable: boolean;
    onboarding?: SupplierOnboardingRequestMessage;
}

export const OfferCardContext = createContext<OfferCardContextInterface>({
    offer: {} as OfferModel,
    order: {} as OrderModel,
    isLastOpenOffer: false,
    isSpotAvailable: false,
});
